import { ActionType, GenericActions } from "./actions";
import { GenericState } from "./state";

export const genericReducer = (
  state: GenericState,
  action: GenericActions
): GenericState => {
  switch (action.type) {
    case ActionType.REWRITE_CHART_TOOLTIP_DATA:
      return { ...state, chartTooltipData: action.payload };
    case ActionType.TOGGLE_CESIUM:
      return { ...state, showCesiumMap: !state.showCesiumMap };
    case ActionType.SET_CESIUM_MODE:
      return { ...state, showCesiumMap: action.payload };
    case ActionType.SET_HOVERED_TRACKPOINT:
      // Unchanged (e.g. cleared again), the state stays the same so nothing rerenders
      if (
        state.hoveredTrackpoint?.index === action.payload?.index &&
        state.hoveredTrackpoint?.fraction === action.payload?.fraction
      ) {
        return state;
      }
      return { ...state, hoveredTrackpoint: action.payload };
    default:
      throw new Error("Invalid action at genericReducer");
  }
};
